var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.016,
    height: 26.016,
    viewBox: "0 0 26.016 26.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_profile-add",
    "data-name": "vuesax/outline/profile-add",
    transform: "translate(-364 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-add",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.149,1.626H.813A.819.819,0,0,1,0,.813.819.819,0,0,1,.813,0H5.149a.819.819,0,0,1,.813.813A.819.819,0,0,1,5.149,1.626Z",
    transform: "translate(14.905 20.325)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.813,5.962A.819.819,0,0,1,0,5.149V.813A.819.819,0,0,1,.813,0a.819.819,0,0,1,.813.813V5.149A.819.819,0,0,1,.813,5.962Z",
    transform: "translate(17.073 18.157)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.8,11.241H5.713a.588.588,0,0,0-.2,0A5.6,5.6,0,0,1,0,5.626,5.522,5.522,0,0,1,1.637,1.658a5.618,5.618,0,0,1,9.6,3.967,5.589,5.589,0,0,1-5.409,5.615ZM5.615,1.626A3.99,3.99,0,0,0,5.474,9.6a1.8,1.8,0,0,1,.347,0A3.969,3.969,0,0,0,9.615,5.615,4.009,4.009,0,0,0,5.615,1.626Z",
    transform: "translate(7.382 1.355)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M8.217,10.981A10.646,10.646,0,0,1,2.331,9.344,4.7,4.7,0,0,1,0,5.474,4.677,4.677,0,0,1,2.331,1.626a11.428,11.428,0,0,1,11.75,0,.819.819,0,0,1,.228,1.127.809.809,0,0,1-1.127.228,9.846,9.846,0,0,0-9.951,0,3.1,3.1,0,0,0-1.6,2.493,3.132,3.132,0,0,0,1.6,2.515A9.023,9.023,0,0,0,8.206,9.344a.818.818,0,0,1,.011,1.637Z",
    transform: "translate(4.781 13.474)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H26.016V26.016H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriend);
export default __webpack_public_path__ + "static/media/friend.9f1ec2ccbe1ed85981e36597356f8041.svg";
export { ForwardRef as ReactComponent };